<template>
    <div v-loading.fullscreen.lock="loading">
        <headerTab :tabList="tabList"></headerTab>
        <div class="wallet">
            <div class="wallet_top">
                <p class="wallet_top_title">总资产</p>
                <div class="wallet_top_allMoney">¥{{fmoney(user.total_money,2)}}</div>
                <div class="wallet_top_action">
                    <div class="wallet_top_action_money">可提现<span>¥{{fmoney(user.money,2)}}</span></div>
                    <el-button class="wallet_top_action_btn" type="primary" @click="goRouter()">余额提现</el-button>
                </div>
            </div>
            <div class="wallet_search">
                <el-form :inline="true">
                     <el-form-item label="时间">
                        <el-date-picker
                            @change="dateChange"
                            v-model="dataTime"
                            style="width:313px"
                            size="mini"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                     </el-form-item>
                     <el-form-item label="类型">
                         <el-select size="mini" @change="selectChange" v-model="type" style="width:100px" placeholder="请选择">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                     </el-form-item>
                </el-form>
                <el-button style="margin-right:40px" type="text" @click="resetForm()">重置</el-button>
            </div>
            <div class="wallet_list" v-if="walletList.length > 0">
                <div class="wallet_list_item" v-for="(item,i) in walletList" :key="i">
                    <div class="wallet_list_item_top">
                        <div>{{item.title}}</div>
                        <div :style="{color:typeValue[item.type] == '-' ? '#FB4841' : '#333'}">{{item.money}}</div>
                    </div>
                    <div class="wallet_list_item_bottom">
                        <div>{{item.create_time}}</div>
                        <div :style="{color:typeValue[item.type] == '-' ? '#FB4841' : '#999'}">{{typeValue[item.type]}}{{item.remark}}</div>
                    </div>
                </div>
            </div>
            <div class="null" v-if="total == 0">
                <img style="margin-top:40px" src="../../assets/null.png" class="null_img" alt="">
                <div class="null_title">暂无数据</div>
            </div>
            <div class="wallet_pagination" v-if="total != 0">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :pager-count="9"
                    @current-change="handleCurrentChange"
                    :current-page="pageNumber"
                    :page-size="pageSize"
                    :total="total">
                </el-pagination>
                <div class="wallet_pagination_right">
                    <div class="wallet_pagination_right_num"><span>{{pageNumber}}</span>/{{lastPage}}</div>
                    <div class="wallet_pagination_right_input">
                        到第
                        <el-input v-model="pageNumberInput" size="small" style="width:63px"></el-input>
                        页
                    </div>
                    <div class="wallet_pagination_right_btn">
                        <el-button size="small" @click="changeNumberInput">确定</el-button>
                    </div>
                </div>
                
            </div>
       </div>
    </div>
   
</template>

<script>
import headerTab from '../../components/header_tab'
export default {
   data (){
       return {
           tabList:[
               {name:'我的钱包',id:1}
           ],
           money:'99999.00',
           useMoney:'12345.00',
           dataTime:[],
           type:0,
           options:[
               {label:'全部',value:0},
               {label:'正价订单',value:1},
               {label:'拼团订单',value:2},
               {label:'提现',value:3},
               {label:'分销佣金',value:4}
           ],
           typeValue:{
               1:'-',
               2:'-',
               3:'+',
               4:'+',
               5:'-',
               6:'+',
               7:'+',
               8:'+',
               9:'-'
           },
           num:1,
           pageSize:10,
           pageNumber:1,
           pageNumberInput:1,
           total:0,
           lastPage:0,
           loading:false,
           walletList:[],
           user:{}
       }
   },
   components: {
       headerTab
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       getUserInfo(){
           this.$get('UserInfo',{})
            .then(data => {
                this.user = data;
            } , error => {
                this.$message.error(error);
            });
       },
       resetForm(){
           this.dataTime = [];
           this.type = 0; 
           this.pageNumber = 1;
            this.pageNumberInput = 1;
           this.getWalletList();
       },
       goRouter(){
           this.$router.push({path:'/withdrawal'});
       },

       //    切换页码
       handleCurrentChange(val){
           this.pageNumber = val;
            this.pageNumberInput = val;
            this.getWalletList();
       },
        // 手动输入页码后确定
       changeNumberInput(){
            if(parseInt(this.pageNumberInput) > this.lastPage){
                this.$message.error('当前页码大于总页码！');
                return 
            }
            this.pageNumber = parseInt(this.pageNumberInput);
            this.getWalletList();
       },
        //日期改变时
        dateChange(){
            this.pageNumber = 1;
            this.pageNumberInput = 1;
            this.getWalletList();
        },
        // 类型改变时
        selectChange(){
            this.pageNumber = 1;
            this.pageNumberInput = 1;
            this.getWalletList();
        },    
       getWalletList(){
           let params = {
               start_time:this.dataTime[0] || '',
               end_time:this.dataTime[1] || '',
               type:this.type,
               page_size:this.pageSize,
               page_index:this.pageNumber
           }
           this.loading = true;
           this.$get('Bill',params)
            .then(data => {
                this.loading = false;
                this.walletList = data.data;
                this.total = data.total;
                this.lastPage = data.last_page;
            }, error => {
                this.loading = false;
                this.$message.error(error);
            });
       },
       fmoney (s, n) {  
            n = n > 0 && n <= 20 ? n : 2;  
            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";  
            var l = s.split(".")[0].split("").reverse(), r = s.split(".")[1];  
            let t = "";  
            for (let i = 0; i < l.length; i++) {  
                t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");  
            }  
            return t.split("").reverse().join("") + "." + r;  
        }  
   },
   created() {
       this.getWalletList();
       this.getUserInfo();
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.wallet{
    padding: 30px 20px 0 20px;
    &_top{
        width:440px;
        height: 145px;
        padding: 20px 20px 12px 20px;
        background:#F7F9FC;
        color:#A6AEC1;
        &_title{
            font-size: 14px;
            
        }
        &_allMoney{
            font-size: 32px;
            color:#009AFF;
            font-weight: 600;
            margin-top:8px;
        }
        &_action{
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            span{
                margin-left:4px;
                color:#009AFF;
                font-weight: 600;
            }
            /deep/ .el-buttom{
                font-size: 16px;
            }
        }
    }
    &_search{
        width:800px;
        display: flex;
        justify-content: space-between;
        padding:5px 10px;
        background: #F7F9FC;
        margin-top:36px;
        /deep/ .el-form-item{
            margin-bottom: 0;
        }
    }
    &_list{
        &_item{
            padding: 12px 40px 12px 16px;
            border-bottom:1px solid #E1E1E1;
            &_top{
                display: flex;
                justify-content: space-between;
                font-size: 18px;
                color:#333;
                font-weight: 600;
            }
            &_bottom{
                display: flex;
                justify-content: space-between;
                margin-top:10px;
                font-size: 14px;
                color:#999999;
                font-weight: 400;
            }
        }
    }
    &_pagination{
        padding-top:30px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color:#000000;
        /deep/ .el-pager li,/deep/ .btn-next, /deep/ .btn-prev{
            min-width: 36px;
            height: 36px;
            padding-top:4px;
            margin: 0 4px;
        }
        /deep/ .btn-prev{
            margin-left: 0;
        }
        &_right{
            display: flex;
            align-items: baseline;
            &_num{
                span{
                    color:#3D7FFF;
                }
                
            }
            &_input{
                margin:0 10px;
            }
            &_btn{
                /deep/ .el-button{
                    background:#F0F2F5;
                    height: 36px;
                    border:1px solid #D7DBE0;
                    font-size: 14px;
                    color:#333;
                }
                /deep/ .el-button:hover{
                    color: #409EFF;
                    border-color: #c6e2ff;
                    background-color: #ecf5ff;
                }
                
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/wallet/wallet.vue